export default "precision mediump float;\n\nvarying vec3 vColor;\n\nvoid main() {\n    gl_FragColor = vec4(vColor.rgb, 1.0);\n}\n";